import { QueryClient } from 'react-query';
import { QueryKey } from 'src/config/queryKey';
import { readFromStorage } from 'src/common/services/queryStorage';

export const localStorageRehydrate = (queryClient: QueryClient) => {
  const authData = readFromStorage(QueryKey.Auth);
  queryClient.setQueryData(QueryKey.Auth, authData);
};
